import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_prenota-diretto/artifacts/qjerng52_logo%20mm.png";

export default function Footer() {
  const { t } = useT();
  return (
    <footer data-testid="site-footer" id="contatti" className="bg-navy-700 text-cream-100 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-11 h-11 rounded-2xl bg-white grid place-items-center">
              <img src={LOGO_URL} alt="Attico Skyline Milano" className="w-7 h-7 object-contain" />
            </span>
            <span className="text-lg font-bold tracking-tight">Attico Skyline Milano</span>
          </div>
          <p className="text-cream-200 text-sm leading-relaxed max-w-sm">
            {t("foot.tagline")}
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 rounded-full border border-cream-200/20 grid place-items-center hover:bg-navy-500 hover:border-navy-500 transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" data-testid="footer-facebook" aria-label="Facebook" className="w-10 h-10 rounded-full border border-cream-200/20 grid place-items-center hover:bg-navy-500 hover:border-navy-500 transition-colors">
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-cream-200 mb-4 font-semibold">{t("foot.contact")}</p>
          <ul className="space-y-3 text-sm text-cream-200">
            <li className="flex items-center gap-2">
              <Mail size={14} /> <a href="mailto:mmspacerents@gmail.com" data-testid="footer-email" className="hover:text-white">mmspacerents@gmail.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} /> <a href="tel:+390000000000" className="hover:text-white">+39 000 000 0000</a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-cream-200 mb-4 font-semibold">{t("foot.info")}</p>
          <ul className="space-y-3 text-sm text-cream-200">
            <li><a href="#" className="hover:text-white">{t("foot.privacy")}</a></li>
            <li><a href="#" className="hover:text-white">{t("foot.cookies")}</a></li>
            <li><a href="#" className="hover:text-white">{t("foot.terms")}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream-200/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 text-xs text-cream-200/70 flex flex-wrap items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} Attico Skyline Milano. {t("foot.rights")}</p>
          <p>{t("foot.craft")}</p>
        </div>
      </div>
    </footer>
  );
}
